import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import animeConfig from '../config/animeConfig';
import './Guides.css';

// All character data verified via Jikan API (api.jikan.moe/v4/characters?q=...)
const characters = [
  {
    name: 'Gol D. Roger',
    title: 'The Pirate King',
    image: 'https://cdn.myanimelist.net/images/characters/3/51747.jpg',
    bio: "The King of the Pirates — the only person to ever conquer the Grand Line and reach Laugh Tale. His execution 24 years ago started the Great Pirate Era when he told the world his treasure was real. His crew included Silvers Rayleigh, Scopper Gaban, and two cabin boys: Shanks and Buggy. His son is Portgas D. Ace.",
    link: '/characters/gol-d-roger'
  },
  {
    name: 'Edward Newgate (Whitebeard)',
    title: 'The Strongest Man in the World',
    image: 'https://cdn.myanimelist.net/images/characters/3/100236.jpg',
    bio: "Captain of the Whitebeard Pirates and one of the Four Emperors. His Tremor-Tremor Fruit could create earthquakes strong enough to destroy the world. He went to war with the entire World Government to save Ace. Died standing at Marineford with zero wounds on his back. His last words confirmed the One Piece is real.",
    link: '/characters/edward-newgate'
  },
  {
    name: 'Portgas D. Ace',
    title: 'Fire Fist, 2nd Division Commander',
    image: 'https://cdn.myanimelist.net/images/characters/2/72220.jpg',
    bio: "The son of Gol D. Roger and Luffy's sworn older brother. Second Division Commander of the Whitebeard Pirates. His Flame-Flame Fruit let him create and become fire. Killed by Admiral Akainu at Marineford while protecting Luffy — one of the most important moments in the series.",
    link: '/characters/portgas-d-ace'
  },
  {
    name: 'Marshall D. Teach (Blackbeard)',
    title: 'Emperor, Admiral of the Blackbeard Pirates',
    image: 'https://cdn.myanimelist.net/images/characters/2/109536.jpg',
    bio: "The only person in history to wield two Devil Fruit powers — the Dark-Dark Fruit and the Tremor-Tremor Fruit stolen from Whitebeard's corpse. Murdered his own crewmate Thatch to get his first fruit, captured Ace to become a Warlord, then used the Marineford War to steal Whitebeard's power. Now one of the Four Emperors.",
    link: '/characters/blackbeard'
  },
  {
    name: 'Sakazuki (Akainu)',
    title: 'Fleet Admiral of the Marines',
    image: 'https://cdn.myanimelist.net/images/characters/16/306908.jpg',
    bio: "The man who killed Ace. His Magma-Magma Fruit burns hotter than fire itself, which is how he punched through Ace's Logia body. Became Fleet Admiral after defeating Aokiji in a 10-day fight on Punk Hazard. Believes in Absolute Justice — he will sacrifice anything, including innocent lives, to wipe out pirates.",
    link: '/characters/sakazuki-akainu'
  },
  {
    name: 'Kuzan (Aokiji)',
    title: 'Former Admiral, Ice-Ice Fruit',
    image: 'https://cdn.myanimelist.net/images/characters/9/96167.jpg',
    bio: "A former Marine Admiral who could freeze entire oceans. Lost to Akainu in a 10-day fight for Fleet Admiral and left the Marines. He let Robin escape as a child because of his friendship with Jaguar D. Saul. Now allied with the Blackbeard Pirates for unknown reasons.",
    link: '/characters/kuzan-aokiji'
  },
  {
    name: 'Borsalino (Kizaru)',
    title: 'Admiral, Glint-Glint Fruit',
    image: 'https://cdn.myanimelist.net/images/characters/12/96168.jpg',
    bio: "A Marine Admiral who moves at the speed of light. Can fire laser beams from his fingertips and form a sword out of light. Despite having arguably the fastest power in the series, he fights with a lazy, unbothered attitude. Single-handedly destroyed the Straw Hats at Sabaody before the timeskip.",
    link: '/characters/borsalino-kizaru'
  },
  {
    name: 'Shanks',
    title: 'Red-Haired Emperor, Captain of the Red Hair Pirates',
    image: 'https://cdn.myanimelist.net/images/characters/9/307639.jpg',
    bio: "One of the Four Emperors and the man who inspired Luffy to become a pirate. Gave Luffy his straw hat and lost his left arm saving him from a Sea King. Once apprenticed on Gol D. Roger's ship alongside Buggy. The three scars across his face came from Blackbeard. Despite rarely fighting on screen, every time he shows up the entire story changes direction — he stopped the Marineford War with a single sentence."
  },
  {
    name: 'Buggy',
    title: 'Current Emperor, Cross Guild Figurehead',
    image: 'https://cdn.myanimelist.net/images/characters/6/69112.webp',
    bio: "A pirate captain who dresses as a clown, and somehow became one of the Four Emperors. Ate the Bara Bara no Mi (Chop-Chop Fruit) as a kid on Gol D. Roger's ship — it lets him split his body into pieces but took away his ability to swim. Failed upward his entire life: from East Blue nobody to Impel Down escapee to Warlord to Emperor. Now the public face of Cross Guild alongside Mihawk and Crocodile, who actually run the organization while Buggy takes the credit and the blame."
  },
  {
    name: 'Silvers Rayleigh',
    title: "The Dark King, First Mate of the Roger Pirates",
    image: 'https://cdn.myanimelist.net/images/characters/16/141861.jpg',
    bio: "The right hand of the Pirate King. First mate of Gol D. Roger and one of the strongest people alive, even decades after Roger's execution. Trained Luffy in all three types of Haki during the two-year timeskip on Rusukaina Island. Lives in semi-retirement on the Sabaody Archipelago, where he works as a ship coater. The Marines know exactly where he is and leave him alone."
  },
  {
    name: 'Charlotte Katakuri',
    title: "Big Mom's Strongest Son, Sweet Commander",
    image: 'https://cdn.myanimelist.net/images/characters/8/342776.jpg',
    bio: "The strongest of Big Mom's 85 children and the first opponent to truly push Luffy past his limits after the timeskip. His Mochi Mochi no Mi lets him reshape his body like mochi and mimic Luffy's own attacks. Has Advanced Observation Haki that lets him see slightly into the future. Their fight in the Mirror World ran 11 hours. Katakuri had a perfect combat record his entire life until Luffy broke it. His bounty is 1,057,000,000 berries."
  },
  {
    name: 'Rob Lucci',
    title: 'CP9 / CP0 Agent, Six Powers Master',
    image: 'https://cdn.myanimelist.net/images/characters/14/71509.jpg',
    bio: "The strongest agent of Cipher Pol No. 9 and the main villain of the Enies Lobby arc. Ate the Cat-Cat Fruit, Model: Leopard, on top of being a master of the Six Powers martial arts. Always carries his pigeon Hattori, who he used as a ventriloquist dummy while undercover at Galley-La Company. After the timeskip he joined CP0, the Celestial Dragons' personal intelligence agency, and is now Spandam's superior — a reversal from their old hierarchy."
  },
  {
    name: 'Dracule Mihawk',
    title: "World's Greatest Swordsman, former Warlord",
    image: 'https://cdn.myanimelist.net/images/characters/7/69747.jpg',
    bio: "The man Zoro has to beat. Carries the black blade Yoru, the strongest sword in the world. A former Warlord of the Sea who now serves as the real military power behind Cross Guild alongside Crocodile, with Buggy as their figurehead. Trained Zoro during the two-year timeskip despite being his ultimate rival. His single-stroke attacks can cut battleships and icebergs."
  },
  {
    name: 'Boa Hancock',
    title: 'Pirate Empress, former Warlord, Captain of the Kuja Pirates',
    image: 'https://cdn.myanimelist.net/images/characters/14/146013.jpg',
    bio: "Ruler of Amazon Lily and the only female Warlord. Her Mero Mero no Mi (Love-Love Fruit) turns anyone attracted to her into stone — and almost everyone is. A former slave of the Celestial Dragons who escaped with her sisters thanks to Fisher Tiger. One of the few characters openly in love with Luffy, and one of even fewer people the World Government sent a full admiral to capture after the Warlord system was abolished."
  },
  {
    name: 'Donquixote Doflamingo',
    title: 'Former Warlord, former King of Dressrosa, Joker',
    image: 'https://cdn.myanimelist.net/images/characters/5/349513.jpg',
    bio: "The main villain of the Dressrosa arc. Born a Celestial Dragon, cast out as a child when his father left Mariejois. Controls the Ito Ito no Mi (String-String Fruit), which lets him create razor-thin strings that cut through buildings and even control people like puppets. Ran the underworld's arms trade under the alias \"Joker\" and secretly ruled Dressrosa by manipulating its king. Defeated by Luffy's Gear Fourth: Boundman. Currently locked in Impel Down Level 6."
  },
  {
    name: 'Monkey D. Garp',
    title: 'Vice Admiral, Hero of the Marines',
    image: 'https://cdn.myanimelist.net/images/characters/5/509073.jpg',
    bio: "Luffy's grandfather and Ace's adoptive grandfather. Fought Gol D. Roger multiple times and was called the Hero of the Marines for cornering the Pirate King. Wanted both Luffy and Ace to become Marines — got two pirates instead. One of the strongest characters in the entire series despite having no Devil Fruit. His fists alone put him on the same level as Roger. He was offered Admiral rank multiple times and always refused."
  },
  {
    name: 'Smoker',
    title: 'Vice Admiral, G-5 Marine Base Commander',
    image: 'https://cdn.myanimelist.net/images/characters/5/235841.jpg',
    bio: "Smoker the White Hunter. A Marine Vice Admiral who has chased Luffy since Loguetown — the first Marine to catch him, and the first to lose him. Ate the Moku Moku no Mi (Smoke-Smoke Fruit). Commander of the G-5 Marine Base, known for rough discipline and rougher soldiers. One of the few Marines who genuinely cares about justice over orders. Fought alongside Luffy against Caesar Clown on Punk Hazard because the situation called for it."
  },
  {
    name: 'Charlotte Linlin (Big Mom)',
    title: 'Former Emperor, Queen of Whole Cake Island',
    image: '/characters/big-mom.webp',
    bio: "Charlotte Linlin, captain of the Big Mom Pirates and queen of Whole Cake Island. Was one of the Four Emperors in the era before Luffy shook things up. Mother of 85 children who she uses to form political marriages across the world. Her Soru Soru no Mi lets her take lifespan from anyone who fears her and put souls into objects, creating an army of living homies — sun, clouds, trees, food. Defeated in Wano by Trafalgar Law and Eustass Kid working together."
  }
];

const GuideCharacters = () => {
  const bgStyle = {
    backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.85)), url(${animeConfig.onePiece.backgroundImage})`,
  };

  return (
    <>
      <Helmet>
        <title>Allies, Enemies and Legends - One Piece Character Guide</title>
        <meta name="description" content="The Emperors, Warlords, Marines, and rivals who define the One Piece world. Shanks, Mihawk, Doflamingo, Garp, Hancock, Katakuri and more with images and facts." />
        <link rel="canonical" href="https://www.onepiecetrivia.com/guides/characters" />
        <meta property="og:title" content="Allies, Enemies and Legends - One Piece" />
        <meta property="og:description" content="The Emperors, Warlords, Marines, and rivals who define the One Piece world." />
        <meta property="og:url" content="https://www.onepiecetrivia.com/guides/characters" />
      </Helmet>

      <div className="guide-page-wrapper" style={bgStyle}>
        <div className="guide-container">
          <h1>Allies, Enemies and Legends</h1>
          <p className="guide-intro">
            The Emperors, Warlords, Marines, and rivals who drive the story forward. Every one of them has crossed paths with Luffy.
          </p>

          {characters.map((char) => (
            <div className="guide-entry guide-entry-with-image" key={char.name}>
              <img
                src={char.image}
                alt={`${char.name} from One Piece`}
                className="guide-entry-image"
                loading="lazy"
              />
              <div className="guide-entry-body">
                <h3>{char.name}</h3>
                <div className="entry-meta">{char.title}</div>
                <p>{char.bio}</p>
              </div>
            </div>
          ))}

          <div className="guide-cta">
            <h2>Can you recognize them all?</h2>
            <p>Match character names to their images in the Image Quiz.</p>
            <Link to="/image-quiz" className="guide-cta-button">Play the Image Quiz</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuideCharacters;
